export enum FileContext {
  FILE_EXTENSION = 'file_extension',
  FILE_MIME = 'mime_type',
  FILE_APPLICATION = 'application'
}




